export default __webpack_public_path__ + "static/media/gitlab.6a62621b.png";